export default __webpack_public_path__ + "static/media/sentimentanalisis2.b8f6557a.jpg";